import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTela, setFiltro, initForm, salvarPortaria, salvar, excluir, getListaPortaria as getLista
} from './controlePatioActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';
import ConfirmModal from '../common/modal/confirmModal';

const columns = [{
    field: 'id_controle_patio',
    type: 'integer'
}, {
    field: 'nome_registro',
    type: 'text'
}, {
    field: 'nome_tipo_registro',
    type: 'text'
}, {
    field: 'nome_setor',
    type: 'text'
}, {
    field: 'datahora_inicio',
    type: 'text'
}, {
    field: 'datahora_fim',
    type: 'text'
}];

class ControlePatioPortaria extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'id_controle_patio',
			direction: 'asc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaSetor();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
    }

	componentWillUnmount() {
		clearInterval(this.idIntervalAtualizacao);
	}
	
    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'executar' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisarPortaria || '').trim()
				|| (this.props.filtro.pesquisarPortaria.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.id}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}
						${item.cavalo}
						${item.carreta1}
						${item.carreta2}
						${item.nome_motorista}
						${item.shipping_saida}
						${item.rumo_saida}
						${item.cliente_saida}
						${item.rumo_saida == 'RS' ? item.fronteira_saida : item.destino_saida}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return listaFiltrada;
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		const heightTela = `${window.innerHeight - 210}px`;

		const usuarioPortaria = !!this.props.listaSetor.filter(item => item.id == 9 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //9 - Portaria
		
		return (
			<ContentCard>

				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem='Confirma que os dados do conjunto estão corretos?'
					textoConfirmar='Sim'
					textoCancelar='Cancelar'
					onConfirm={() => {
						const { itemConfirmacao } = this.state;

						if (itemConfirmacao) {
							this.props.salvarPortaria({
								...itemConfirmacao
							});
						}

						this.setState({
							confirmacao: false,
							itemConfirmacao: null
						});
					}}
					onCancel={() => {
						this.setState({
							confirmacao: false,
							itemConfirmacao: null
						});
					}}
				/>

				<ContentCardBody>

					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisarPortaria}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisarPortaria: value })} />
					</Row>
					
					<div style={{ display: 'flex', flexDirection: 'column', gap: 12, height: heightTela, overflowY: 'auto' }}>
						{lista.filter(item => {
							const setor = this.props.listaSetor.filter(itemSetor => itemSetor.id == item.id_setor)[0];

							return true;//setor && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(setor.permissao);

						}).map((item, i) => {
							
							const selecionado = this.state.linhaSelecionada == item.id
							
							// const setor = this.props.listaSetor.filter(itemSetor => itemSetor.id == item.id_setor)[0];

							// const usuarioGestor = ['GESTOR'].includes(setor.permissao);
							// const usuarioSupervisor = ['SUPERVISOR'].includes(setor.permissao);

							return (
								<div
									key={item.id}
									onClick={() => this.setState({ linhaSelecionada: item.id })}
									style={{
										border: '1px solid #dcdcdc',
										borderRadius: 8,
										padding: 12,
										backgroundColor: selecionado ? '#bcc7eb' : '#ffffff',
										boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
										cursor: 'pointer'
									}}
								>
									{/* Linha 2 */}
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										<div><strong>Controle:</strong> {item.id}</div>
										<div><strong>Liberação de Saída:</strong> {DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}</div>
									</div>
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
											<div><strong>Cavalo:</strong> {item.cavalo}</div>
										</div>

										<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
											<div><strong>Carreta:</strong> {item.carreta1}{item.carreta1 && item.carreta2 ? ' | ' : ''}{item.carreta2}</div>
										</div>
									</div>
									
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										<div><strong>Motorista:</strong> {item.nome_motorista}</div>
									</div>

									{(item.shipping_saida || item.rumo_saida) &&
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
										<div><strong>SC:</strong> {item.shipping_saida}</div>
										<div><strong>Rumo:</strong> {item.rumo_saida}</div>
									</div>}
									{item.cliente_saida && 
									<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Cliente:</b> {item.cliente_saida}</div>
									</div>}
									<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
										{item.rumo_saida == 'RS' &&
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Fronteira:</b> {item.fronteira_saida}</div>}
										{item.rumo_saida != 'RS' &&
										<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Destino:</b> {item.destino_saida}</div>}
									</div>
									
									{/* Datas e botões */}
									{usuarioPortaria &&
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											marginTop: 10,
											flexWrap: 'wrap',
											gap: 8
										}}>
										<a className='btn btn-app bg-success'
											style={{ marginBottom: 0, marginLeft: 0 }}
											onClick={() => {
												this.abrirConfirmacao(item);
											}}>
											<i className='fas fa-check'></i> Confirmar
										</a>
									</div>}
								</div>
							)
						})}
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}

	abrirConfirmacao(item) {
		this.setState({
			confirmacao: true,
			itemConfirmacao: item
		});
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTela,
	lista: state.controlePatio.listaPortaria,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvarPortaria, salvar, excluir, getLista, getListaSetor
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioPortaria);
